import { getCss, buildResponsiveStyles, mergeDeep, color as colorUtils } from "../../utils";
import { ICON_SIZE } from "./icon-utils";
export const createStyles = (color, size) => {
    const styles = getCss({
        '@global': {
            ':host': {
                display: 'inline-flex',
                color: 'inherit',
            },
            i: Object.assign({ display: 'flex', color: 'inherit' }, mergeDeep(buildResponsiveStyles(size, (sizeResponsive) => ({
                width: `${ICON_SIZE[sizeResponsive]}px`,
                height: `${ICON_SIZE[sizeResponsive]}px`,
            })))),
            svg: Object.assign({ width: '100%', height: '100%' }, mergeDeep(buildResponsiveStyles(color, (colorResponsive) => ({
                fill: colorResponsive === 'inherit'
                    ? 'inherit'
                    : colorResponsive === 'currentColor'
                        ? 'currentColor'
                        : colorUtils[colorResponsive],
            })))),
        },
    });
    return styles;
};
//# sourceMappingURL=icon-styles.js.map
